import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/layout/Footer";

export default function PolitiqueConfidentialite() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white pt-20 text-black">
      <section className="px-6 pb-4 pt-10">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-semibold leading-tight">
            Politique de confidentialité
          </h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 16/04/2026</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="mx-auto max-w-3xl space-y-10 text-[15px] leading-7 text-gray-800">
          <p>
            La présente politique de confidentialité a pour objet d’informer les
            utilisateurs du site <span className="font-medium">savoinimaux.fr</span>{" "}
            sur la manière dont leurs données personnelles peuvent être collectées,
            utilisées, conservées et protégées dans le cadre de leur navigation et
            de leurs échanges avec l’association Savoinimaux.
          </p>

          <p>
            L’association Savoinimaux attache une importance particulière au respect
            de la vie privée et s’engage à traiter les données personnelles dans le
            respect du Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et de la loi
            Informatique et Libertés du 6 janvier 1978 modifiée.
          </p>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              1. Responsable du traitement
            </h2>
            <p>
              Le responsable du traitement des données personnelles collectées sur
              le site est :
            </p>
            <ul className="mt-3 list-none space-y-1 pl-0">
              <li>
                <span className="font-medium">Dénomination :</span> SAVOINIMAUX
              </li>
              <li>
                <span className="font-medium">Forme juridique :</span> Association
                régie par la loi du 1er juillet 1901
              </li>
              <li>
                <span className="font-medium">Siège social :</span> 47 Rue du Pont
                Neuf, 74150 Rumilly
              </li>
              <li>
                <span className="font-medium">Téléphone :</span> +33 (0)6 44 68 52
                53
              </li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:savoinimaux@gmail.com" className="underline">
                  savoinimaux@gmail.com
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              2. Données collectées
            </h2>
            <p>
              Selon l’utilisation du site, l’association peut être amenée à
              collecter les données suivantes :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Nom et prénom ;</li>
              <li>Adresse e-mail ;</li>
              <li>Numéro de téléphone, si renseigné ;</li>
              <li>Contenu des messages envoyés via les formulaires ;</li>
              <li>Données techniques de navigation ;</li>
              <li>Préférences de consentement relatives aux cookies.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              3. Finalités du traitement
            </h2>
            <p>Les données personnelles peuvent être utilisées pour :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Répondre aux demandes de contact ou de renseignement ;</li>
              <li>Traiter les signalements ou demandes liés à l’association ;</li>
              <li>Assurer le fonctionnement et la sécurité du site ;</li>
              <li>
                Mesurer l’audience du site, uniquement après consentement lorsque
                cela est requis ;
              </li>
              <li>
                Afficher certains contenus externes, uniquement après consentement
                lorsque cela est requis ;
              </li>
              <li>Respecter les obligations légales et réglementaires.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              4. Bases légales du traitement
            </h2>
            <p>
              Les traitements de données personnelles reposent, selon les cas, sur :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Le consentement de l’utilisateur ;</li>
              <li>
                L’exécution de mesures précontractuelles ou contractuelles ;
              </li>
              <li>L’intérêt légitime de l’association ;</li>
              <li>Le respect d’une obligation légale.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              5. Destinataires des données
            </h2>
            <p>
              Les données collectées sont destinées uniquement aux personnes
              habilitées au sein de l’association Savoinimaux ainsi qu’à ses
              prestataires techniques lorsque cela est strictement nécessaire à
              l’exploitation du site ou au traitement d’une demande.
            </p>
            <p className="mt-3">
              Elles ne sont ni vendues, ni cédées, ni louées à des tiers à des fins
              commerciales.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              6. Durée de conservation
            </h2>
            <p>
              Les données personnelles sont conservées pendant une durée limitée,
              proportionnée aux finalités poursuivies.
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                Données de contact : jusqu’à 3 ans à compter du dernier échange ;
              </li>
              <li>
                Préférences cookies : jusqu’à 6 mois à compter de leur enregistrement
                ;
              </li>
              <li>
                Données techniques : durée adaptée aux besoins de sécurité et de bon
                fonctionnement du site.
              </li>
            </ul>
            <p className="mt-3">
              Certaines données peuvent être conservées plus longtemps si une
              obligation légale l’impose.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              7. Droits des utilisateurs
            </h2>
            <p>
              Conformément à la réglementation applicable, vous disposez des droits
              suivants :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Droit d’accès ;</li>
              <li>Droit de rectification ;</li>
              <li>Droit à l’effacement ;</li>
              <li>Droit à la limitation du traitement ;</li>
              <li>Droit d’opposition ;</li>
              <li>Droit au retrait du consentement à tout moment ;</li>
              <li>Droit d’introduire une réclamation auprès de la CNIL.</li>
            </ul>
            <p className="mt-3">
              Pour exercer vos droits, vous pouvez écrire à :{" "}
              <a href="mailto:savoinimaux@gmail.com" className="underline">
                savoinimaux@gmail.com
              </a>
            </p>
            <p className="mt-3">
              En cas de difficulté, vous pouvez également saisir la{" "}
              <a
                href="https://www.cnil.fr"
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                CNIL
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              8. Sécurité des données
            </h2>
            <p>
              L’association Savoinimaux met en œuvre des mesures techniques et
              organisationnelles raisonnables afin de protéger les données
              personnelles contre la perte, l’altération, l’accès non autorisé ou
              la divulgation non autorisée.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              9. Cookies et traceurs
            </h2>
            <p>
              Le site utilise des cookies strictement nécessaires à son bon
              fonctionnement ainsi que, selon votre choix, des cookies de mesure
              d’audience ou des traceurs liés à des contenus externes.
            </p>
            <p className="mt-3">
              Pour plus d’informations, vous pouvez consulter notre{" "}
              <Link to="/politique-cookies" className="underline">
                Politique de cookies
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              10. Mise à jour de la politique
            </h2>
            <p>
              La présente politique de confidentialité peut être modifiée à tout
              moment afin de tenir compte des évolutions légales, réglementaires,
              techniques ou des modifications apportées au site.
            </p>
            <p className="mt-3">
              Les utilisateurs sont invités à la consulter régulièrement.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}